import {Directive, ElementRef, inject, Input} from '@angular/core';

/**
 * @description Directive that allows to refer to a DOM element from a parent component template,	without having to use ViewChild.
 */
@Directive({
	selector: '[DomReferer]',
	standalone: true,
})
export class DomRefererDirective<T = any> {
	// TODO: Skipped for migration because:
	//  Accessor inputs cannot be migrated as they are too complex.
	@Input({
		required: true,
	})
	public set DomReferer(props: {ref: T; fn: (ref: T, elementRef: HTMLElement) => void; el?: HTMLElement}) {
		if (!props || !props.ref || !props.fn) return;
		props.fn(props.ref, props.el || this.elementRef.nativeElement);
	}

	constructor(private readonly elementRef: ElementRef<HTMLElement> = inject(ElementRef<HTMLElement>)) {}
}
